import { useState } from 'react';
import { communitySections } from '@/mocks/gossip';

export default function Circles() {
  const [joined, setJoined] = useState<Record<string, boolean>>({});

  return (
    <section id="circles" className="bg-background-50 py-12 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-bold text-secondary-700">
              <i className="ri-team-fill" />
              吃瓜圈子 · 分区运营
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              按你口味，挑个圈子蹲前排
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              直播、科技、饭圈到夜聊楼，每个圈子都有专属搬瓜员和实时热聊。挑一个，进去跟大伙唠。
            </p>
          </div>
          <span className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-50 px-4 py-2 text-xs font-bold text-secondary-700">
            <i className="ri-signal-wifi-fill" />
            全站 6.8 万人在线吃瓜
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {communitySections.map((s) => (
            <article
              key={s.key}
              className="flex items-center gap-4 rounded-3xl border border-background-200 bg-background-50 p-5 transition hover:border-primary-200"
            >
              <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-2xl ${s.color}`}>
                <i className={s.icon} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-black text-foreground-950">{s.name}</h3>
                  <span className="flex items-center gap-1 text-[11px] font-medium text-accent-600">
                    <i className="ri-record-circle-fill text-[8px]" />
                    {s.online}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-600">{s.desc}</p>
              </div>
              <button
                type="button"
                onClick={() => setJoined((j) => ({ ...j, [s.key]: !j[s.key] }))}
                className={`flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-3.5 py-2 text-xs font-bold transition ${
                  joined[s.key]
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                }`}
              >
                {joined[s.key] ? (
                  <>
                    <i className="ri-check-line" /> 已蹲
                  </>
                ) : (
                  '去蹲前排'
                )}
              </button>
            </article>
          ))}
        </div>

        {/* 深夜运营横幅 */}
        <div className="relative mt-8 overflow-hidden rounded-3xl bg-primary-500 p-8 md:p-10">
          <div className="pointer-events-none absolute -right-16 -top-16 h-52 w-52 rounded-full bg-primary-400/40" />
          <div className="pointer-events-none absolute -bottom-20 left-1/3 h-40 w-40 rounded-full bg-accent-400/30" />
          <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h3 className="font-heading text-xl font-black text-background-50 md:text-2xl">
                新瓜速递凌晨也在补，夜猫子的前排从不掉队
              </h3>
              <p className="mt-2 max-w-xl text-sm text-primary-50">
                最新瓜持续更新，聊天记录与截图实时归档。订阅前排提醒，事件一抬头就喊你起床。
              </p>
            </div>
            <button
              type="button"
              onClick={() => setJoined((j) => ({ ...j, notify: !j.notify }))}
              className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-bold transition ${
                joined.notify
                  ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                  : 'bg-background-50 text-primary-700 hover:bg-background-100'
              }`}
            >
              {joined.notify ? (
                <>
                  <i className="ri-notification-off-fill" /> 已静音提醒
                </>
              ) : (
                <>
                  <i className="ri-notification-fill" /> 开启前排提醒
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}